// @flow

import * as React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';
import type { AriaLabelPropType } from '../types';

const Type: Object = Object.freeze({
  Email: 'Email',
  Number: 'Number',
  Tel: 'Tel',
  Password: 'Password',
  Search: 'Search',
  Text: 'Text',
  URL: 'URL',
});

export type TextInputPropType = {|
  ...AriaLabelPropType,
  className?: string,
  type: $Values<typeof Type>,
  disabled: boolean,
  defaultValue?: string,
  placeholder?: string,
  required?: boolean,
  name?: string,
  background?: 'Default' | 'Dark',
|};

const TextInput = (props: TextInputPropType) => {
  const classes = classnames(
    styles.textInput,
    props.className,
    props.background === 'Dark' && styles.isDark,
  );
  const { 'aria-label': ariaLabel } = props;

  return (
    <input
      name={props.name}
      className={classes}
      type={props.type.toLowerCase()}
      disabled={props.disabled}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      required={props.required}
      aria-label={ariaLabel}
    />
  );
};

TextInput.defaultProps = {
  type: Type.Text,
  disabled: false,
  background: 'Default',
};

export default TextInput;
